module.exports = __webpack_public_path__ + "static/media/fall.c0cb5f81.svg";